import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, PeopleAlt as PhoneReassignedNumberIcon} from "@material-ui/icons"
import React from "react"

import {CustomerPhoneReassignedNumberActivityPayload} from "@indebted/api"

function PhoneReassignedNumberActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {Title: string; HappenedAt: string; Payload: CustomerPhoneReassignedNumberActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
	isReassigned: boolean,
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<PhoneReassignedNumberIcon style={{color: isReassigned ? "#E31D1D" : "#2F853D"}} />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Phone number:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Phone}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {PhoneReassignedNumberActivity}
